export default __webpack_public_path__ + "4a32c40e0501ee884862b44c02a0a309.png";